import type { LangStrings } from './en';

export const ja: LangStrings = {
  back: '戻る',
  next: '次へ',
  retry: 'リトライ',
  replay: 'リプレイ',
  sector: 'セクター',
  sectors: 'セクター',
  levels: 'レベル',
  cleared: 'クリア',
  open: 'オープン',
  locked: 'ロック',
  tba: 'TBA',
  slot_reserved: '予約スロット',
  sfx_on: 'SFX オン',
  sfx_off: 'SFX オフ',
  reset_progress: 'プログレス削除',
  wiped_reloading: '削除完了, リロード中…',
  got_it: '› 了解 ‹',

  boot_eyebrow: 'カスケード・プロトコル  //  BUILD',
  boot_tagline: 'ワンタップ。ワンカスケード。やり直し無し。',
  boot_subtitle: '信号崩壊  ·  CASCADE LOGIC',
  boot_cta: '› タップして開始 ‹',
  boot_region: 'リージョン ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // オンライン',

  menu_header_subtitle: 'NØDUS / セクター選択',
  menu_engine_label: '信号崩壊エンジン',
  menu_signals_down: '信号撃破',
  menu_tap_chapter: 'チャプターをタップして入る',
  menu_language_label: '言語',

  chapter_signals_down: '信号撃破',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: 'コーダ',
  chapter_coda_tagline: '新しいものはなし。すべてを組み合わせる。',

  hud_tap_to_breach: '▾  ノードをタップして突破  ▾',
  hud_tap_to_skip: "スキップ  ▸▸",
  hud_drag_zoom_help: 'ドラッグで移動 · ホイール/ピンチでズーム',
  hud_required: '必須',
  hud_core_online: 'コア稼働中',
  hud_core_down: 'コア撃破',

  tut_tap_any_node: 'どのノードでもタップ',
  tut_they_all_work: 'ここは全部当たり',

  brief_eyebrow: '◂ ブリーフィング ▸',
  brief_title: 'ワンタップ。\nワンカスケード。',
  brief_line_1: '› タップは1回のみ。',
  brief_line_2: '› ネットワーク上で連鎖反応が走る。',
  brief_line_3: '› 全ての必須ノード（シアン菱形）を崩して勝利。',
  brief_line_4: '› 保護ノード（赤）には絶対にパルスを当てない。',
  brief_begin: '› ブリーフィング開始 ‹',

  result_win_headline: 'システム崩壊',
  result_fail_headline: 'カスケード失敗',
  result_first_clear: '› 初クリア ‹',
  result_try_label: '› 試して',
  result_cleared_suffix: 'クリア済',
  result_aborted_suffix: '実行中断',
  result_win_body_template: '{ticks}ティック。{nodes}ノード撃破。',

  fail_protected_overload: '保護ノードがオーバーロード。カスケードが触れてはいけない場所を撃った。',
  fail_forbidden_trigger: '禁止線が信号を運んだ。重警報発動。',
  fail_required_not_reached: '必須ノードにパルスが届かなかった。連鎖が到達せず。',
  fail_required_under_threshold: '必須ノードへのパルスが足りなかった。1発目が減衰してから2発目が届いた。',
  fail_core_not_collapsed: 'コアは生存。カスケードが届く前に消えた。',
  fail_core_under_threshold: 'コアにパルスは届いたが不足。集束が間に合わず。',
  fail_core_shielded: 'コアへのパルスがブロックされた。シールドがまだ動作中。',
  fail_chain_died: '何にも届かないまま連鎖が消えた。',
  fix_protected_overload: 'カスケードが赤い危険ノードに届かないスターターを選べ。各スターターの下流を先にトレースしろ。',
  fix_forbidden_trigger: '赤い破線ワイヤーに向けて発火するスターターは避けろ。触れた瞬間にアラームが鳴る。',
  fix_required_not_reached: 'スターターがそのノードに繋がっていない。矢印を見ろ, 方向性ワイヤーは一方通行だ。',
  fix_required_under_threshold: '2本のパルスを届けるルートを見つけろ, スプリッターか2つの集束経路でいける。',
  fix_core_not_collapsed: 'コアへの集束をもっと増やせ。スプリッター、キャパシタ、リレーがそのためにある。',
  fix_core_under_threshold: 'パルスが遅すぎる。スプリッターで重ねるか、全部同じティックに着弾させろ。',
  fix_core_shielded: '決定打が届く前に全シールドを落とせ。遅延ワイヤーを遅れて着弾させるのが綺麗。',
  fix_chain_died: 'スターターが1つのノードにしか繋がっていない。網の中央を選べ。',

  popup_new_node: '◂ 新ノードタイプ ▸',
  popup_new_wire: '◂ 新ワイヤータイプ ▸',

  node_normal_title: 'ノード',
  node_normal_tagline: '基本単位。タップでカスケード開始。',
  node_normal_b1: '最初のパルスで崩壊する。',
  node_normal_b2: '開いている全ての出力ワイヤーにパルスを発射。',
  node_normal_b3: '閾値なし, 一撃で消える。',

  node_required_title: '必須ノード',
  node_required_tagline: '全ての必須ノードを崩して勝利。',
  node_required_b1: 'シアンの菱形。アイドル時は微かに脈動して目立つ。',
  node_required_b2: '一部は同じウィンドウで2発以上のパルスが必要。',
  node_required_b3: '1つでも逃したら実行失敗。',
  node_required_note: 'ノード周りの小さな点リングが充電進捗を示す。',

  node_protected_title: '保護ノード',
  node_protected_tagline: '触れたら実行全体が即死。',
  node_protected_b1: '赤いハザードクロス。角ブラケット付き。',
  node_protected_b2: 'パルスが触れた瞬間に即時失敗。',
  node_protected_b3: '絶対に到達しないルートを計画しろ。',

  node_relay_title: 'リレー',
  node_relay_tagline: '崩壊するとロック線を開く。',
  node_relay_b1: '金のシェブロン。ターゲットは破線のロック線。',
  node_relay_b2: 'リレーが落ちると、そのロック線が開通する。',
  node_relay_b3: 'ガードされたノードへの経路を開くのに使える。',

  node_shield_title: 'シールド',
  node_shield_tagline: 'ボディガード。別のノードの代わりに被弾する。',
  node_shield_b1: '保護対象を囲む緑の六角リング。',
  node_shield_b2: 'シールド中のノードへの直撃は無効。',
  node_shield_b3: 'まずシールドを落とせ, 続けて決定打を撃て。',
  node_shield_note: '遅延ワイヤー（金の破線）はシールド後の一撃に最適。',

  node_splitter_title: 'スプリッター',
  node_splitter_tagline: '全出力にパルスを増幅する。',
  node_splitter_b1: 'マゼンタの分岐。1パルス入力 → 出力毎にN発。',
  node_splitter_b2: 'Xマーカーが分割係数を示す。',
  node_splitter_b3: '高閾値のコアに必要な多重ヒットを供給する。',

  node_capacitor_title: 'キャパシタ',
  node_capacitor_tagline: 'パルスを蓄えて再発射, バッファ。',
  node_capacitor_b1: '黄色のキャパシタ記号。パルスを3ティック後に転送。',
  node_capacitor_b2: 'ルート内蔵の遅延として扱え。',
  node_capacitor_b3: '後発パルスをシールド落下後に着弾させられる。',

  node_core_title: 'コア',
  node_core_tagline: '目標。高閾値、高速減衰。',
  node_core_b1: '紫の反応炉。多くの集束パルスで落ちる。',
  node_core_b2: '充電は減衰する, パルスは密集して届かせろ。',
  node_core_b3: 'よくシールドで守られている。シールドを落としてからコアを浸せ。',
  node_core_note: 'コアがあるレベルはコア崩壊で勝利。必須ノード（あれば）も加算。',

  wire_directional_title: '方向性ワイヤー',
  wire_directional_tagline: '一方通行導体。シアンと矢印。',
  wire_directional_b1: 'パルスは矢印方向のみ進む。',
  wire_directional_b2: '矢印の反対側からタップしても流れない。',
  wire_directional_b3: 'スターターから矢印を辿って最後まで確認しろ。',

  wire_delay_title: '遅延ワイヤー',
  wire_delay_tagline: '金の破線。パルスは3ティック後に到着。',
  wire_delay_b1: 'タイミング用, シールド落下後にパルスを着弾。',
  wire_delay_b2: 'または高閾値ノードに2発を重ねる用。',
  wire_delay_b3: 'タイミングを外すと1発目が先に減衰する。',

  wire_locked_title: 'ロック線',
  wire_locked_tagline: '灰色破線＋南京錠。何かが開くまで閉じている。',
  wire_locked_b1: '各ロック線はリレーが制御している。',
  wire_locked_b2: 'リレーが崩壊するとそのロック線が一気に開く。',
  wire_locked_b3: 'ロック線に直接給電しようとタップを浪費するな。',

  wire_forbidden_title: '禁止線',
  wire_forbidden_tagline: '赤い破線＋十字。触れたら即時失敗。',
  wire_forbidden_b1: '通過パルスでもアラーム発動。',
  wire_forbidden_b2: '各スターターの出力線を必ず確認しろ。',
  wire_forbidden_b3: '絶対に赤に触れないルートのスターターを選べ。',

  wire_burn_title: '焼損ワイヤー',
  wire_burn_tagline: '真鍮オレンジ。一発限定の導体, パルス通過後に焼け落ちる。',
  wire_burn_b1: '正確に1パルスだけ運び、永久に死ぬ。',
  wire_burn_b2: 'その1回の使用を慎重に計画しろ, やり直しなし。',
  wire_burn_b3: '一度焼けたら、どのカスケードも通せない。',

  callout_required_crashed: '必須ノード撃破',
  callout_core_breached: 'コア突破',
  callout_shield_dropped: 'シールド落下',
  callout_relay_opened: 'リレー開放',
  callout_protected_hit: '保護ノード被弾',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: 'タップ位置',
  result_map_broke: 'ここで失敗',
  result_map_answer: '正解',
  result_show_answer: '答えを見る',
  menu_endless_line: '生成レベル、ライフは3つ。深く進むほど手強くなる。',
  menu_best: 'ベスト LV {n}',
  menu_best_streak: 'ベスト LV {n}  ·  連勝 ×{s}',
  menu_resume: '再開 LV {n}',
  menu_start: 'スタート LV 1',
  result_run_total: 'ラン合計 {n}',
  result_streak: '連勝 ×{n}',
  result_streak_wins: '{n}連勝中',
  legend_title: '凡例',
  legend_nodes: 'ノード',
  legend_wires: 'ワイヤー',
  legend_close: 'どこかをタップして閉じる',
  settings_sync_now: '今すぐ同期 ({who})',
  settings_sign_in: 'ログインして同期',
  settings_sign_out: 'ログアウト',

};
